import moment from 'moment-timezone'
import tzlookup from 'tz-lookup'

export const generalHelpers = {
  isEqual,
  arrayDiff,
  calculateTimeDifferences,
  calculateTimeDifferencesJustNumber,
  addEvent,
  removeEvent,
  constructAlgoliaDateFilterString,
  moveArrayElement,
  parseGoogleDate,
  groupByObjects,
  mergeArrays,
  compareObjectPropertyLength,
  compareObjectProperty,
  copyToClipboard,
  camelize,
  dateToAWSDateTime,
  dateToWeekDay,
  delay,
  compareArrayOfObjects,
  calculateVolume
}
/**
 * function for comparing objects and array if they are equal
 * from article (https://gomakethings.com/check-if-two-arrays-or-objects-are-equal-with-javascript/)
 */
function isEqual (value, other) {
  // Get the value type
  var type = Object.prototype.toString.call(value)

  // If the two objects are not the same type, return false
  if (type !== Object.prototype.toString.call(other)) return false

  // If items are not an object or array, return false
  if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false

  // Compare the length of the length of the two items
  var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length
  var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length
  if (valueLen !== otherLen) return false

  // Compare two items
  var compare = function (item1, item2) {
    // Get the object type
    var itemType = Object.prototype.toString.call(item1)

    // If an object or array, compare recursively
    if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
      if (!isEqual(item1, item2)) return false
    } else { // Otherwise, do a simple comparison
      // If the two items are not the same type, return false
      if (itemType !== Object.prototype.toString.call(item2)) return false

      // Else if it's a function, convert to a string and compare
      // Otherwise, just compare
      if (itemType === '[object Function]') {
        if (item1.toString() !== item2.toString()) return false
      } else {
        if (item1 !== item2) return false
      }
    }
  }

  // Compare properties
  if (type === '[object Array]') {
    for (var i = 0; i < valueLen; i++) {
      if (compare(value[i], other[i]) === false) return false
    }
  } else {
    for (var key in value) {
      if (value.hasOwnProperty(key)) {
        if (compare(value[key], other[key]) === false) return false
      }
    }
  }

  // If nothing failed, return true
  return true
}

function arrayDiff (oldArray, newArray) {
  if (newArray === undefined) {
    newArray = []
  }
  if (oldArray === undefined) {
    oldArray = []
  }
  let added = []
  let removed = []
  oldArray.forEach(el => {
    if (!newArray.includes(el)) {
      removed.push(el)
    }
  })
  newArray.forEach(el => {
    if (!oldArray.includes(el)) {
      added.push(el)
    }
  })
  return { added: added, removed: removed }
}
// Calculate the diff between two timestamps and return value in (s)econds/(m)inutes/(h)ours/(d)ays
function calculateTimeDifferences (from, to) {
  moment.tz.setDefault('UTC')
  let timeTo = null
  let timeFrom = moment.unix(from)
  if (!timeFrom.isValid()) {
    timeFrom = moment(from)
  }
  if (to !== undefined) {
    timeTo = moment.unix(to)
    if (!timeTo.isValid()) {
      timeTo = moment(to)
    }
  } else {
    timeTo = moment()
  }
  if (timeTo.isValid() && timeFrom.isValid()) {
    const diff = moment.duration(timeTo.diff(timeFrom))
    switch (true) {
      case (diff.asSeconds() < 60):
        return Math.ceil(diff.asSeconds()) + ' s'
      case (diff.asMinutes() < 60):
        return Math.ceil(diff.asMinutes()) + ' m'
      case (diff.asHours() < 24):
        return Math.ceil(diff.asHours()) + ' h'
      default:
        return Math.ceil(diff.asDays()) + ' d'
    }
  } else {
    return 0
  }
}
function calculateTimeDifferencesJustNumber (from, to) {
  moment.tz.setDefault('UTC')
  let timeTo = null
  let timeFrom = moment.unix(from)
  if (!timeFrom.isValid()) {
    timeFrom = moment(from)
  }
  if (to !== undefined) {
    timeTo = moment.unix(to)
    if (!timeTo.isValid()) {
      timeTo = moment(to)
    }
  } else {
    timeTo = moment()
  }
  if (timeTo.isValid() && timeFrom.isValid()) {
    const diff = moment.duration(timeTo.diff(timeFrom)).asHours()
    return diff
  } else {
    return 0
  }
}
// Polyfill addEventListener (Support: IE9)
function addEvent (object, type, callback) {
  if (object == null || typeof (object) === 'undefined') return
  if (object.addEventListener) {
    object.addEventListener(type, callback, false)
  } else if (object.attachEvent) {
    object.attachEvent('on' + type, callback)
  } else {
    object['on' + type] = callback
  }
}
// Polyfill removeEventListener (Support: IE9)
function removeEvent (object, type, callback) {
  if (object == null || typeof (object) === 'undefined') return
  if (object.addEventListener) {
    object.removeEventListener(type, callback, false)
  } else if (object.attachEvent) {
    object.detachEvent('on' + type, callback)
  } else {
    object['on' + type] = callback
  }
}
function constructAlgoliaDateFilterString (filters) {
  let indexes = Object.keys(filters)
  let algoliaFilter = ''
  if (indexes.length === 0) {
    algoliaFilter = ''
  } else if (indexes.length === 1) {
    algoliaFilter = filters[indexes[0]] // get first/only one date filter
  } else {
    indexes.forEach(index => {
      algoliaFilter += filters[index]
      if (index !== indexes[indexes.length - 1]) { // if not last filter in object
        algoliaFilter += ' AND '
      }
    })
  }
  return algoliaFilter
}
// Move element in array from oldIndex to newIndex
function moveArrayElement (array, oldIndex, newIndex) {
  while (oldIndex < 0) {
    oldIndex += array.length
  }
  while (newIndex < 0) {
    newIndex += array.length
  }
  if (newIndex >= array.length) {
    var k = newIndex - array.length
    while ((k--) + 1) {
      array.push(undefined)
    }
  }
  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0])
  return array
}
// parse google date to timestamp

function parseGoogleDate (d) {
  console.log(moment(d).format('HH:mm'))
  // let googleDate = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})([+-]\d{2}):(\d{2})$/
  let appSyncDate = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})([A-Z])$/
  var m = appSyncDate.exec(d)
  if (m !== null) {
    var year = +m[1]
    var month = +m[2]
    var day = +m[3]
    var hour = +m[4]
    var minute = +m[5]
    var second = +m[6]
    // var msec   = +m[7]
    // var tzHour = +m[8]
    // var tzMin  = +m[9]
    // var tzOffset = new Date().getTimezoneOffset() + tzHour * 60 + tzMin
    return new Date(year, month - 1, day, hour, minute, second)
  } else {
    return '000000000000'
  }
}

function get (obj, path, def) {
	/**
	 * If the path is a string, convert it to an array
	 * @param  {String|Array} path The path
	 * @return {Array}             The path array
	 */
	var stringToPath = function (path) {

		// If the path isn't a string, return it
		if (typeof path !== 'string') return path

		// Create new array
		var output = []

		// Split to an array with dot notation
		path.split('.').forEach(function (item, index) {

			// Split to an array with bracket notation
			item.split(/\[([^}]+)\]/g).forEach(function (key) {

				// Push to the new array
				if (key.length > 0) {
					output.push(key)
				}
			})
		})
		return output
  }
  	// Get the path as an array
	path = stringToPath(path)
	// Cache the current object
	var current = obj

	// For each item in the path, dig into the object
	for (var i = 0; i < path.length; i++) {

		// If the item isn't found, return the default (or null)
		if (!current[path[i]]) return def

		// Otherwise, update the current  value
		current = current[path[i]]

	}

	return current
}
function groupByObjects (xs, key) {
  return xs.reduce(function (rv, x) {
    // (rv[x[key]] = rv[x[key]] || []).push(x)
    (rv[get(x, key)] = rv[get(x, key)] || []).push(x)
    return rv
  }, {})
}
function mergeArrays (a, b, i = 0) {
  return a.splice(i, 0, ...b) && a
}
function compareObjectPropertyLength (property) {
  return function (a, b) {
    if (a[property].length > b[property].length) {
      return -1
    }
    if (a[property].length < b[property].length) {
      return 1
    }
    return 0
  }
}
function compareObjectProperty (property) {
  return function (a, b) {
    if (a[property] > b[property]) {
      return -1
    }
    if (a[property] < b[property]) {
      return 1
    }
    return 0
  }
}

function copyToClipboard (text) {
  const el = document.createElement('textarea')
  el.value = text
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}

function camelize (str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return '' // or if (/\s+/.test(match)) for white spaces
    // eslint-disable-next-line eqeqeq
    return index == 0 ? match.toLowerCase() : match.toUpperCase()
  })
}

function dateToAWSDateTime (date, coordinates) {
  let timezone = 'Europe/Prague'
  if (coordinates != null) {
    timezone = tzlookup(coordinates.lat, coordinates.lng)
  }
  if (moment.unix(date).isValid()) {
    const returnedTime = moment.unix(date).tz(timezone).format()
    return returnedTime
  } else {
    const returnedTime = moment(date).tz(timezone).format()
    return returnedTime
  }
}
function dateToWeekDay (date, coordinates, lang) {
  if (lang != null) {
    moment.locale(lang)
  }
  let timezone = 'Europe/Prague'
  if (coordinates != null) {
    timezone = tzlookup(coordinates.lat, coordinates.lng)
  }
  if (date != null) {
    if (moment.unix(date).isValid()) {
      const returnedTime = moment.unix(date).tz(timezone).format('dddd')
      return returnedTime
    } else {
      const returnedTime = moment(date).tz(timezone).format('dddd')
      return returnedTime
    }
  } else {
    return moment().tz(timezone).format('dddd')
  }
}

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

// Serialize array of object to json and comparing to strings
function compareArrayOfObjects(a, b) {
  return JSON.stringify(a) === JSON.stringify(b)
}

function calculateVolume (dimensions) {
  if (dimensions.width != null && dimensions.length != null && dimensions.height) {
    return Math.round(dimensions.width * dimensions.length * dimensions.height)
  }
  return null
}
